/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PhotoUploaderMutationVariables = {|
  fileName: string
|};
export type PhotoUploaderMutationResponse = {|
  +getPreSignedUrl: {|
    +url: any,
    +fields: any,
  |}
|};
export type PhotoUploaderMutation = {|
  variables: PhotoUploaderMutationVariables,
  response: PhotoUploaderMutationResponse,
|};
*/


/*
mutation PhotoUploaderMutation(
  $fileName: String!
) {
  getPreSignedUrl(fileName: $fileName) {
    url
    fields
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "fileName"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "fileName",
        "variableName": "fileName"
      }
    ],
    "concreteType": "S3PreSignedURL",
    "kind": "LinkedField",
    "name": "getPreSignedUrl",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fields",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PhotoUploaderMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PhotoUploaderMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "84cb1a2e9a6d2ed64b33e276839fe94a",
    "id": null,
    "metadata": {},
    "name": "PhotoUploaderMutation",
    "operationKind": "mutation",
    "text": "mutation PhotoUploaderMutation(\n  $fileName: String!\n) {\n  getPreSignedUrl(fileName: $fileName) {\n    url\n    fields\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'fa98f9c3e98728b9b82c9e32489b81f4';

module.exports = node;
